export default __webpack_public_path__ + "static/media/_Sieger.73c82f12.png";